import { useSelector } from 'react-redux'
import { State } from 'src/state'
import DraftSetting from './DraftSetting'
import PartyModeSetting from './PartyModeSetting'
import MaintenanceSetting from './MaintenanceSetting'
import TrackingSetting from './TrackingSetting'
import MultipleSectionsSetting from './MultipleSectionsSetting'
import NutritionalLinkSetting from './NutritionalLinkSetting'

export default function AdvancedSettings() {
  const { user } = useSelector((state: State) => state.users)

  if (!user) {
    return null
  }

  const environment = (process.env.REACT_APP_ENV || 'production').toLowerCase()
  const isProductionEnvironment = environment === 'production'
  const showsDraftSetting =
    !isProductionEnvironment || user.username === 'ambercaffe' || user.username === 'demo' || user.username === 'indianbistro'

  return (
    <>
      <MultipleSectionsSetting />
      <TrackingSetting />
      <NutritionalLinkSetting />
      <PartyModeSetting />
      {showsDraftSetting && <DraftSetting />}
      <MaintenanceSetting />
    </>
  )
}
